/**
 * Shared date/time formatting helpers for the appointments module.
 * Delegates to canonical Unify helpers (ENG-3287).
 */

import {
  formatUsDateShort,
  formatUsDateTime,
  formatUsTimeRange,
} from '@/lib/dateHelpers';

export function formatDateTime(dateStr: string): string {
  return formatUsDateTime(dateStr);
}

export function formatShortDateTime(iso: string): string {
  return formatUsDateTime(iso);
}

export function formatShortDate(iso: string): string {
  if (/^\d{4}-\d{2}-\d{2}$/.test(iso.trim())) {
    return formatUsDateShort(iso.trim());
  }
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return formatUsDateShort(d);
}

export function formatLinkedDate(dateStr: string | undefined): string {
  if (!dateStr) return '--';
  if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr.trim())) {
    return formatUsDateShort(dateStr.trim()) || '--';
  }
  const d = new Date(dateStr);
  if (Number.isNaN(d.getTime())) return dateStr;
  return formatUsDateShort(d) || '--';
}

export function formatLinkedTime(start: string | undefined, end: string | undefined): string {
  return formatUsTimeRange(start, end);
}
